export default __webpack_public_path__ + "static/pyramid-40f5aed5c0509114cc876c1ca3b5311f.png";